import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navbar from "@Shared/components/general/nav-bar.vue";
import { encode64 } from "@Broker/js/custom/utils";
import { mapActions, mapGetters, mapState } from "vuex";
import { CREATE_TEMPLATE, LOAD_TEMPLATES, DELETE_TEMPLATE, LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE } from "../../store/templates/templates-actions";
import { GET_TEMPLATES_CATEGORIES, GET_TEMPLATE_BY_ID } from "../../store/templates/templates-getters";
import { SAVE_STAGE, SAVE_CURRENT_CAMPAIGN } from "@Broker/@Modules/automation/drip-campaign/store/drip-campaign-actions";
import TemplateCard from "@Broker/@Modules/marketing/templates/components/template-card.vue";
import CreateEmailTemplateModal from "@Broker/@Modules/util-components/html-template-editor/modals/create-email-template-modal.vue";
import Loader from "@Shared/utils/preload";
import TemplatesHeader from "./templates-header.vue";
import TemplatesLoader from "./templates-loader.vue";
import { showToast } from "@Shared/@Utils/constants";
import HtmlTemplateEditor from "@Broker/@Modules/util-components/html-template-editor.vue";
import Err from "@Broker/@Routes/error";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEmpty, kebabCase, pickBy, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TemplatesContainer",
  title() {
    return this.$t("sidebar.sections.marketingTemplates");
  },
  components: {
    TemplatesHeader,
    TemplateCard,
    CreateEmailTemplateModal,
    Navbar,
    TemplatesLoader,
    HtmlTemplateEditor
  },
  async beforeRouteLeave(to, from, next) {
    var _this$$refs;
    if (!((_this$$refs = this.$refs) != null && _this$$refs.templateEditorContainer)) return next();
    const canContinue = await this.$refs.templateEditorContainer.confirmExit();
    next(canContinue);
  },
  props: {
    isSelectPage: {
      type: Boolean,
      default: false
    },
    backPath: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      currentTab: "",
      search: "",
      createId: 0,
      creating: false,
      refreshing: false,
      createSucceeded: true,
      showSavedMessage: false,
      previewTemplate: false,
      selectedTemplateId: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("TemplatesStore", [GET_TEMPLATES_CATEGORIES, GET_TEMPLATE_BY_ID])), mapState("TemplatesStore", {
    currentTemplate(state) {
      return state.currentTemplate;
    },
    userCreatedTemplates(state) {
      var _context;
      const userCreated = pickBy(state.userCreated.byId, ({
        name
      }) => (this.currentTab === "all" || this.currentTab === "saved") && this.searchFilter(name));
      return _sortInstanceProperty(_context = values(userCreated)).call(_context, (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    },
    predefinedTemplates(state) {
      const systemTemplates = pickBy(state.predefinedTemplates.byId, ({
        category,
        name
      }) => (this.currentTab === "all" || this.currentTab === "predefined" ? true : this.currentTab === kebabCase(category)) && this.searchFilter(name));
      return values(systemTemplates);
    },
    allTemplates() {
      return [...this.userCreatedTemplates, ...this.predefinedTemplates];
    }
  })), {}, {
    selectedTemplateData() {
      const templateData = this.GET_TEMPLATE_BY_ID(this.selectedTemplateId) || {
        templateId: 0 //default template for creation
      };
      return _objectSpread(_objectSpread({}, this.currentTemplate), templateData);
    },
    categories() {
      var _context2;
      return _mapInstanceProperty(_context2 = this.GET_TEMPLATES_CATEGORIES).call(_context2, category => ({
        value: kebabCase(category),
        label: this.$t("templates.categories")[category] || category
      }));
    },
    getTitle() {
      return this.isSelectPage ? this.$t("templates.selectTitle") : this.$tc("templates.template", 2);
    },
    getSubtitle() {
      return this.isSelectPage ? "" : this.$t("templates.subtitle");
    },
    isCurrentTemplateEmpty() {
      var _isEmpty, _this$currentTemplate, _this$currentTemplate2;
      return (_isEmpty = isEmpty((_this$currentTemplate = this.currentTemplate) == null ? void 0 : (_this$currentTemplate2 = _this$currentTemplate.templateId) == null ? void 0 : _this$currentTemplate2.toString())) != null ? _isEmpty : true;
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Templates - visited");
  },
  async mounted() {
    this.loading = true;
    await this.loadTemplates();
    this.currentTab = this.GET_TEMPLATES_CATEGORIES[0];
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("TemplatesStore", [LOAD_TEMPLATES, DELETE_TEMPLATE, CREATE_TEMPLATE, LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE])), mapActions("DripCampaignStore", [SAVE_STAGE, SAVE_CURRENT_CAMPAIGN])), {}, {
    async loadTemplates() {
      await this.LOAD_TEMPLATES();
    },
    handleTabChange(tab) {
      this.currentTab = tab;
      Amplitude.logEvent("Templates - classification tab changed", {
        tab
      });
    },
    async handleTemplateEdit(templateId) {
      Amplitude.logEvent("Templates - edit template clicked", {
        templateId
      });
      await this.LOAD_MARKETING_TEMPLATE(templateId);
      this.selectedTemplateId = templateId;
      this.initBee();
    },
    async handleTemplatePreview(templateId) {
      Amplitude.logEvent("Templates - preview template clicked", {
        templateId
      });
      const isUserCreated = this.isUserCreated(templateId);
      this.selectedTemplateId = templateId;
      if (isUserCreated) {
        await this.LOAD_MARKETING_TEMPLATE(templateId);
      }
      this.previewTemplate = true;
      this.initBee();
    },
    async createTemplate(templateName) {
      Amplitude.logEvent("Templates - create template clicked", {
        templateName
      });
      this.creating = true;
      try {
        const templateId = await this.CREATE_TEMPLATE({
          name: templateName,
          selectedTemplateId: this.selectedTemplateId
        });
        await this.LOAD_MARKETING_TEMPLATE(templateId);
        await this.loadTemplates();
        this.createSucceeded = true;
        this.$refs.createModal.hideModal();
        this.selectedTemplateId = templateId;
        this.initBee();
      } catch (e) {
        this.createSucceeded = false;
        Err.handle(e);
      } finally {
        this.creating = false;
      }
    },
    async handleTemplateCreateNew() {
      Amplitude.logEvent("Templates - create as new template clicked");
      this.selectedTemplateId = 0;
      this.showCreateModal();
    },
    async initBee() {
      this.$refs.templateEditorContainer.mountPlugin();
      this.showSavedMessage = false;
    },
    async handleEditorSave({
      jsonTemplate,
      htmlTemplate
    }) {
      const json = encode64(jsonTemplate);
      const html = encode64(htmlTemplate);
      await this.UPDATE_TEMPLATE({
        templateId: this.selectedTemplateId,
        data: {
          json,
          html
        }
      });
      this.refreshTemplates();
      if (this.showSavedMessage) showToast("success", "templateSaved");else this.showSavedMessage = true;
      Loader.stop();
    },
    showCreateModal() {
      this.$refs.createModal.showModal();
    },
    async handleTemplateDelete(templateId) {
      Amplitude.logEvent("Templates - delete template clicked", {
        templateId
      });
      await this.DELETE_TEMPLATE(templateId);
    },
    isUserCreated(templateId) {
      const {
        category
      } = this.GET_TEMPLATE_BY_ID(templateId);
      return isEmpty(category);
    },
    async handleEditorSaveAs({
      templateId
    }) {
      this.selectedTemplateId = templateId;
      await this.LOAD_MARKETING_TEMPLATE(templateId);
      await this.loadTemplates();
    },
    handleTemplateDuplicate(templateId) {
      Amplitude.logEvent("Templates - duplicate template clicked", {
        templateId
      });
      this.selectedTemplateId = templateId;
      this.showCreateModal();
    },
    async handleSelect(templateId) {
      Amplitude.logEvent("Templates - select template clicked", {
        templateId
      });
      const {
        name,
        thumbnail
      } = this.GET_TEMPLATE_BY_ID(templateId);
      const templateData = {
        templateId,
        templateName: name,
        templateThumbnail: thumbnail
      };
      if (this.$route.query.fromDripCampaign === "true") {
        const {
          index
        } = this.$route.query;
        this.SAVE_STAGE({
          data: templateData,
          index
        });
        this.SAVE_CURRENT_CAMPAIGN({
          fromTemplate: true
        });
        return this.$router.replace({
          path: this.backPath
        });
      }
      if (this.$route.query.fromAutomation === "true") {
        const {
          automationId,
          trigger,
          editMode,
          subject,
          previewText
        } = this.$route.query;
        return this.$router.replace({
          name: "application-automations",
          params: {
            templateData,
            openAutomation: automationId,
            openTrigger: trigger,
            selectedTemplate: true,
            editMode,
            subjectData: {
              subject,
              previewText
            }
          }
        });
      }
      if (this.$route.query.fromCampaign === "true") {
        this.UPDATE_CURRENT_TEMPLATE(templateData);
        return this.$router.replace({
          path: this.backPath
        });
      }
    },
    searchFilter(name) {
      var _context3;
      return isEmpty(this.search) || _includesInstanceProperty(_context3 = name.toLowerCase()).call(_context3, this.search.toLowerCase());
    },
    async refreshTemplates() {
      Amplitude.logEvent("Templates - refresh template button clicked");
      this.refreshing = true;
      await this.loadTemplates();
      this.refreshing = false;
    },
    handleEditorHidden() {
      this.loadTemplates();
      this.previewTemplate = false;
    }
  })
});